import React from "react";
import "../Styles.css";
import { UseGlobalState } from "../../state/gsh/gsh";
import { Image } from "@fluentui/react-northstar";

import { DOMAIN_PANE, HELP_PANE } from "./constants";

export default function HelpPane() {
    const [state, setState] = UseGlobalState()

    const handleClick = () => {
        state.loginPane = DOMAIN_PANE
        setState(state)
    }

    return (
        <div>
            {state.loginPane === HELP_PANE &&
                <div className="reactModalProgURL">
                    <div className="loginModalProgURLBody1"><Image src="color.png" className="cnxt-logo"/>&nbsp;&nbsp;<span className="loginModalProgURLBody12">CultureNext</span></div><br />
                    <div className="loginModalProgURLBody0">
                        <div className="loginModalProgURLBody2">HELP</div>
                        <div className="loginModalProgURLBody6">Why do you need a recognition program URL?</div>
                        <div className="loginModalProgURLBody8">The CultureNext Microsoft Teams app uses your program website URL (www.exampleprogram.culturenxt.com) to sync with your company's recognition program.  Microsoft Teams will pull in all of the recognition details from the website, and vice versa.</div>
                        <div className="loginModalProgURLBody6">What if I don't know my recognition program URL?</div>
                        <div className="loginModalProgURLBody8">If you don't know your program website URL, try logging in through your normal methods of accessing the recognition program and look for the URL.  You can also ask your manager or colleague.</div>
                        <br/>
                        <div className="loginModalProgURLBody5"><a href="#" onClick={() => { handleClick(); return false; }}>Back to URL Login</a></div>
                    </div>
                </div>
            }
        </div>
    );
}